import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { AppRecentModelBase } from '../../model/application/app-recent.model';

@Injectable({
    providedIn: 'root'
})
export class AppRecentApiService {

    protected resourceUrl: string = '/rest/publicarea/app-recent'

    constructor(private http: HttpClient) { }

    public putApp(appCode: string): Observable<{ ok: boolean, messageCode: string, entity: boolean }> {
        return this.http.get<{ ok: boolean, messageCode: string, entity: boolean }>(
            `${this.resourceUrl}/putApp/${appCode}`
        )
    }

    public getAppsCodesByUserEntity(): Observable<{ ok: boolean, messageCode: string, entity: AppRecentModelBase[] }> {
        return this.http.get<{ ok: boolean, messageCode: string, entity: AppRecentModelBase[] }>(
            `${this.resourceUrl}/getAppsCodesByUserEntity`
        ).pipe(map(response => {
            response.entity = response.entity.map(item => AppRecentModelBase.from(item));
            return response;
        }))
    }

    // Delete this method after some time, this is to persist actual localstorage data to backend, in case there are users with the old version of the frontend
    public putAppsCodesByUserEntity(appsCodes: string[]): Observable<{ ok: boolean, messageCode: string, entity: boolean }> {
        return this.http.post<{ ok: boolean, messageCode: string, entity: boolean }>(
            `${this.resourceUrl}/putAppsCodesByUserEntity`,
            { appsCodes }
        )
    }

}